import { API_CONFIG, API_HEADERS } from "../../config/ApiConfig";
import { axiosApi } from "./AaxiosUtil";

/**
 *
 * @param {*} path  API PATH
 * @param {*} data  Optional in GET
 * @param {*} isSendAuthToken  send true for authentocated calls false for non-login users
 * @returns POST / MULTI Form API CALL RESPONSE
 */
export const postRequest = (path, formData = null, isSendAuthToken = false) => {
  let apiUrl = API_CONFIG.API_HOST + path;

  return axiosApi
    .post(apiUrl, formData, {
      headers: isSendAuthToken
        ? {
            "api-access-key": API_CONFIG.ACCESS_KEY,
            Authorization: "Bearer " + localStorage.getItem("authToken"),
            "Content-Type": "multipart/form-data",
          }
        : API_HEADERS,
    })
    .then((response) => {
      // FAILBLOCK block
      if (response.status === 401) {
        // handle error
      } else {
        // return the response

        return response;
      }
    })
    .catch((error) => {
      // error block
      return error.response;
    });
};
